import { trimString } from "./preset-workspace-ui-model.js";

function element(tagName, className = "", text = "") {
  const node = document.createElement(tagName);
  node.className = className;
  node.textContent = text;
  return node;
}

export function presetChangeValueText(value, present) {
  if (!present) {
    return "—";
  }
  const encoded = JSON.stringify(value);
  const text = encoded === undefined ? String(value) : encoded;
  return text.length > 72 ? `${text.slice(0, 69)}…` : text;
}

export function presetChangeDisplayName(change) {
  const presented = trimString(change?.presentation?.name);
  if (presented) {
    return presented;
  }
  const segments = Array.isArray(change?.pathSegments) ? change.pathSegments : [];
  const leaf = segments.at(-1);
  if (leaf?.kind === "index") {
    const parent = [...segments].reverse().find((segment) => segment?.kind === "property");
    const collection = trimString(parent?.name) || "Collection";
    return `${collection
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/[_-]+/g, " ")
      .replace(/^./, (letter) => letter.toUpperCase())} · Item ${leaf.index + 1}`;
  }
  const property = leaf?.kind === "property" ? trimString(leaf.name) : "Setting";
  return property
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/^./, (letter) => letter.toUpperCase());
}

export function presetChangeSignalKey(change) {
  return trimString(change?.presentation?.signalKey) || trimString(change?.path);
}

export function renderPresetChangeValue(change, side) {
  const old = side === "old";
  const descriptor = old
    ? change?.presentation?.oldValue
    : change?.presentation?.newValue;
  const fallback = presetChangeValueText(
    old ? change?.savedValue : change?.workingValue,
    old ? change?.savedPresent : change?.workingPresent,
  );
  const value = element("span", "flex min-w-0 items-center gap-1.5");
  if (descriptor?.kind === "zone" && descriptor.rgb) {
    const indicator = element("span", "fishy-zone-rgb-indicator shrink-0");
    indicator.setAttribute("aria-hidden", "true");
    indicator.style.setProperty("--fishy-zone-rgb", descriptor.rgb);
    value.append(indicator);
  }
  value.append(element("span", "min-w-0 break-words", trimString(descriptor?.text) || fallback));
  return value;
}
